export default __webpack_public_path__ + "media/images/burger-de299cc0b4d02da4e5ba8e9c7cf40ca4.svg";